<template>
  <el-table border :data="tableData" height="55%" ref="sortTable4" :summary-method="getSummaries" show-summary
            @sort-change="sortChangeEvt" header-align="center" v-if="num != null"
            v-sort-orders="['descending', 'ascending', '']">
    <el-table-column prop="name" label="项目名称" width="315" fixed sortable="custom">
      <template slot-scope="props">
        <span class="white_over" :style="{ color: props.row.name_color == '1' ? '#000' : '#f00' }">
          {{ props.row.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column prop="" label="规划" width="82" sortable="custom" v-tooltip="'这是年龄列'">
    </el-table-column>
    <el-table-column prop="type_birdview" label="鸟瞰" width="100" sortable="custom">
    </el-table-column>
    <el-table-column prop="type_perspective" label="透视" width="100" sortable="custom">
    </el-table-column>
    <el-table-column prop="type_indoor" label="室内" width="100" sortable="custom">
    </el-table-column>
    <el-table-column prop="type_vr" label="VR" width="100" sortable="custom">
    </el-table-column>
    <el-table-column prop="type_animation" label="动画" width="100" sortable="custom">
    </el-table-column>
    <el-table-column prop="yproduction" label="1组-杨长伟" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际产值'" placement="top">
          <span>1组-杨长伟</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="zproduction" label="2组-胡适堡" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际产值'" placement="top">
          <span>2组-胡适堡</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cproduction" label="3组-陈章" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际产值'" placement="top">
          <span>3组-陈章</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_production" label="4组-程尉东" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际产值'" placement="top">
          <span>4组-程尉东</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_production" label="5组" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际产值'" placement="top">
          <span>5组</span>
        </el-tooltip>
      </template>
    </el-table-column>


    <el-table-column prop="y_back" label="1组-杨长伟" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际回款'" placement="top">
          <span>一组-杨长伟</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="z_back" label="2组-胡适堡" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际回款'" placement="top">
          <span>2组-胡适堡</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="c_back" label="3组-陈章" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际回款'" placement="top">
          <span>3组-陈章</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_back" label="4组-程尉东" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际回款'" placement="top">
          <span>4组-程尉东</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_back" label="5组" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'实际回款'" placement="top">
          <span>5组</span>
        </el-tooltip>
      </template>
    </el-table-column>

    <el-table-column prop="yratio" label="1组-杨长伟" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'产值比例'" placement="top">
          <span>1组-杨长伟</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="zratio" label="2组-胡适堡" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'产值比例'" placement="top">
          <span>2组-胡适堡</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="cratio" label="3组-陈章" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'产值比例'" placement="top">
          <span>3组-陈章</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_ratio" label="4组-程尉东" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'产值比例'" placement="top">
          <span>4组-程尉东</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_ratio" label="5组" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'产值比例'" placement="top">
          <span>5组</span>
        </el-tooltip>
      </template>
    </el-table-column>


    <el-table-column prop="money" label="规划" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
          <span>规划</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ytype_birdview" label="鸟瞰" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
          <span>鸟瞰</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ytype_perspective" label="透视" width="80" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
          <span>透视</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ytype_indoor" label="室内" width="80" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
          <span>室内</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ytype_vr" label="VR" width="80" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
          <span>VR</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ytype_animation" label="动画" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'杨长伟'" placement="top">
          <span>动画</span>
        </el-tooltip>
      </template>
    </el-table-column>

    <el-table-column prop="money" label="规划" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
          <span>规划</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ztype_birdview" label="鸟瞰" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
          <span>鸟瞰</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ztype_perspective" label="透视" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
          <span>透视</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ztype_indoor" label="室内" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
          <span>室内</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ztype_vr" label="VR" width="120" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
          <span>VR</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ztype_animation" label="动画" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'胡适堡'" placement="top">
          <span>动画</span>
        </el-tooltip>
      </template>
    </el-table-column>

    <el-table-column prop="" label="规划" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'陈章'" placement="top">
          <span>规划</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ctype_birdview" label="鸟瞰" width="82" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'陈章'" placement="top">
          <span>鸟瞰</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ctype_perspective" label="透视" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'陈章'" placement="top">
          <span>透视</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ctype_indoor" label="室内" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'陈章'" placement="top">
          <span>室内</span>
        </el-tooltip>
      </template>
    </el-table-column>

    <el-table-column prop="ctype_vr" label="VR" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'陈章'" placement="top">
          <span>VR</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="ctype_animation" label="动画" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'陈章'" placement="top">
          <span>动画</span>
        </el-tooltip>
      </template>
    </el-table-column>


    <el-table-column prop="" label="规划" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'程卫东'" placement="top">
          <span>规划</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_birdview" label="鸟瞰" width="82" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'程卫东'" placement="top">
          <span>鸟瞰</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_perspective" label="透视" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'程卫东'" placement="top">
          <span>透视</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_indoor" label="室内" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'程卫东'" placement="top">
          <span>室内</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_vr" label="VR" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'程卫东'" placement="top">
          <span>VR</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="four_animation" label="动画" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'程卫东'" placement="top">
          <span>动画</span>
        </el-tooltip>
      </template>
    </el-table-column>


    <el-table-column prop="" label="规划" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'五组'" placement="top">
          <span>规划</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_birdview" label="鸟瞰" width="82" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'五组'" placement="top">
          <span>鸟瞰</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_perspective" label="透视" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'五组'" placement="top">
          <span>透视</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_indoor" label="室内" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'五组'" placement="top">
          <span>室内</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_vr" label="VR" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'五组'" placement="top">
          <span>VR</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="five_animation" label="动画" width="100" sortable="custom">
      <template slot="header">
        <el-tooltip effect="dark" :content="'五组'" placement="top">
          <span>动画</span>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: ["tableData", "num"],

  directives: {
    tooltip: {
      bind(el, binding) {
        el.addEventListener('mouseenter', function () {
          const tooltip = document.createElement('div');
          tooltip.className = 'tooltip';
          tooltip.innerText = binding.value;
          document.body.appendChild(tooltip);
          const rect = el.getBoundingClientRect();
          tooltip.style.top = rect.top + 'px';
          tooltip.style.left = rect.left + 'px';
        });
        el.addEventListener('mouseleave', function () {
          const tooltip = document.querySelector('.tooltip');
          if (tooltip) {
            tooltip.remove();
          }
        });
      }
    }
  },
  data() {
    return {
      activeIndex: '1',
      //排序
      order: null,
      orField: null,
      totalRow: null,
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    clearSort() {
      this.$refs.sortTable4.clearSort();
    },
    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    //分页
    handleCurrentChange(res) {
      // this.loading = true
      // setTimeout(() => {
      //   this.loading = false
      // }, 100)
    },

    //列表排序
    sortChangeEvt(row) {
      let a = {
        orWhere: row.prop,
      }
      if (row.order === 'ascending') {
        a.order = 'asc';
      } else if (row.order === 'descending') {
        a.order = 'desc';
      } else if (row.order === null) {
        a.order = '';
        a.orWhere = '';
      }
      this.$emit('Min_BOX', a)
    },
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        for (let key in this.$props.num.totalRow) {
          if (column.property == key) {
            sums[index] = this.$props.num.totalRow[key];
          }
        }
      });
      return sums;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../style/Media_Query.less");

.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 17px;
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
  z-index: 100;
  /* 使Header在其他内容之上 */
}

/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 60px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  margin-left: 155px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  margin-top: 70px;
}

/deep/ .el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}

/deep/ .el-icon-arrow-down:before {
  content: "";
}

.edit {
  width: 1000px;
  height: 80px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    margin-left: 6px;
  }

  span {
    width: 55px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589FF9;
    line-height: 26px;
    margin-left: 5px;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }

}

/deep/ .el-table th.el-table__cell {
  background: #DCE6EE;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 0 !important;
}

/deep/ .el-table__footer-wrapper {
  position: fixed;
  top: 175px;
  z-index: 111;
  background-color: #F5F7FA;
}

/deep/ .el-table__fixed {
  background: #fff !important;
}

.mainx {
  margin-top: 50px;
}

.white_over {
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/list.vue